import React, { useState } from 'react';
import { Box, IconButton, Link } from '@material-ui/core';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import { DropdownFilter } from '../../../Planner/Filters/DropdownFilter';
import { logTypeEnums } from '../../../../settings/other';
import KeyboardDateSelector from '../../../common/KeyboardDateTimeSelectors/KeyboardDateSelector';
import { isValidDate } from '../../../../utils/dates';
import globals from '../../../../globals/communityGlobals';

export default function AutoAllocationFilters({ onSubmit, defaultModel }) {
  const [state, setState] = useState(defaultModel);
  const [defaultState] = useState(defaultModel);

  const onChangeFilters = () => {
    onSubmit(state);
  };

  const clear = () => {
    setState(defaultState);
    onSubmit(state);
  };

  const handleDateChange = date => {
    setState(prevState => ({
      ...prevState,
      selectedDate: date ? moment(date).format(globals.dateFormats.localApiFormat) : date,
    }));
  };

  return (
    <section className="slick-page-header-section">
      <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
        <Box p={1}>
          <FilterListIcon />
        </Box>
        <Box p={1} width={70} textAlign="end">
          <span>Log type</span>
        </Box>
        <Box p={1} width={400} flexGrow={1}>
          <DropdownFilter
            data={logTypeEnums}
            filterKey={'logType'}
            filterValue={state.logType}
            defaultValue={['']}
            onChange={(name, value) => setState({ ...state, logType: value })}
          />
        </Box>
        <Box p={1} width={80} textAlign="end">
          <span>Date</span>
        </Box>
        <KeyboardDateSelector
          id="validto-picker-inline"
          value={state.selectedDate}
          onChange={date => handleDateChange(date)}
          className="calendar-picker-input"
          disableToolbar
        />
        <Box p={1} width={50} />
        <Box p={1}>
          <Link className="cancel-link" onClick={clear}>
            Clear
          </Link>
        </Box>
        <Box p={1}>
          <IconButton
            type="submit"
            size="small"
            onClick={onChangeFilters}
            className="search-icon"
            disabled={!isValidDate(state.selectedDate, true)}
          >
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
    </section>
  );
}
